// =============================================
// EmbedNodeView — renders a notesEmbed as a SANDBOXED, allow-listed video iframe
// =============================================
import React from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import { FiX, FiAlertTriangle } from 'react-icons/fi';
import { embedSrc, providerLabel } from './embedUtils';

const EmbedNodeView: React.FC<NodeViewProps> = ({ node, editor, deleteNode }) => {
  const provider: string = node.attrs.provider;
  const videoId: string = node.attrs.videoId;
  // src is rebuilt from a trusted template every render — never a stored free-form URL.
  const src = embedSrc(provider, videoId);

  return (
    <NodeViewWrapper className="note-embed-node" data-provider={provider}>
      <div className="nen-frame">
        {editor.isEditable && (
          <button className="nen-remove" onClick={() => deleteNode()} title="Remove" aria-label="Remove embed" contentEditable={false}>
            <FiX size={14} />
          </button>
        )}
        {!src ? (
          <div className="nen-error"><FiAlertTriangle size={16} /> Unsupported embed</div>
        ) : (
          <div className="nen-aspect">
            <iframe
              className="nen-iframe"
              src={src}
              title={`${providerLabel(provider)} video`}
              // allow-same-origin here is SAFE: the framed src is a different origin
              // (youtube-nocookie.com / player.vimeo.com), so the grant applies to the
              // provider's own origin, never ours — it can't script our page. The player
              // needs it (+ allow-scripts) to run; popups open the "watch on …" link.
              sandbox="allow-scripts allow-same-origin allow-presentation allow-popups"
              allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen"
              allowFullScreen
              referrerPolicy="strict-origin-when-cross-origin"
              loading="lazy"
            />
          </div>
        )}
        <div className="nen-badge">{providerLabel(provider)}</div>
      </div>
    </NodeViewWrapper>
  );
};

export default EmbedNodeView;
